import { doc, updateDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { Timestamp } from 'firebase/firestore';

export async function updateUserSubscriptionTier(userId: string, tier: string) {
  try {
    const userRef = doc(db, 'users', userId);
    
    await updateDoc(userRef, {
      subscription: {
        tier,
        startDate: Timestamp.now(),
        autoRenew: true,
        analysisCount: 0,
        lastResetDate: Timestamp.now()
      }
    });
  } catch (error) {
    console.error('Error updating subscription tier:', error);
    throw error;
  }
}